const unloadTenantConfigAction = (state) => {
  localStorage.removeItem('tenant');
  return {
    ...state,
    tenant: null,
  };
};

export default unloadTenantConfigAction;
